module.exports = __webpack_public_path__ + "img/86.8.TSS.d15fb1df.png";